import { default as RBaseStyle } from './RBaseStyle';
/**
 * An abstract class serving as base for all styles that render an image
 */
class RImage extends RBaseStyle {
    /* istanbul ignore next */
    create(props) {
        throw new Error('RImage is an abstract class');
    }
    set(ol) {
        if (!this.context.style.setImage)
            throw new Error('Parent element does not support an image');
        this.context.style.setImage(ol);
    }
}
RImage.classProps = [
    'opacity',
    'rotateWithView',
    'rotation',
    'scale',
    'displacement'
];
export default RImage;
//# sourceMappingURL=RImage.js.map